import { normalizeTrimText } from "@me-team/host/src/utils/utils";

type BuildTranslationTextVmParams = {
    translatedValue?: string | null;
    originValue?: string | null;
    isTranslationMode: boolean;
};

export type TranslationTextVm = {
    displayText: string;
    placeholderText: string | null;
    isMissingTranslation: boolean;
};

export const buildTranslationTextVm = ({
    translatedValue,
    originValue,
    isTranslationMode,
}: BuildTranslationTextVmParams): TranslationTextVm => {
    const normalizedTranslatedValue = normalizeTrimText(translatedValue);
    const normalizedOriginValue = normalizeTrimText(originValue);

    const hasTranslated = Boolean(normalizedTranslatedValue);
    const hasOrigin = Boolean(normalizedOriginValue);

    const isMissingTranslation = Boolean(isTranslationMode && !hasTranslated && hasOrigin);

    return {
        displayText: hasTranslated ? normalizedTranslatedValue : normalizedOriginValue,
        placeholderText: isMissingTranslation ? normalizedOriginValue : null,
        isMissingTranslation,
    };
};
